import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WixQuestionEditor.css';

// The Design tab's limit (widgetCustomizationTab.js MAX_PREDEFINED_CHARS); the backend generates within it too.
const MAX_CHARS = 40;

export default function WixQuestionEditor({ questions = [], onChange }) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(null);
  const update = (index, text) => onChange(questions.map((q, i) => i === index ? text : q));
  return <section className="wix-question-editor" aria-label={t('wxo_questions_edit')}>
    <div className="wix-question-editor-heading">
      <span>{t('wxo_questions_edit')}</span><span>{questions.length}/3</span>
    </div>
    <div className="wix-question-chips">
      {questions.map((question, index) => editing === index ?
        <div key={index} className="wix-question-input-row">
          <input autoFocus aria-label={`${t('predefined_question')} ${index + 1}`} maxLength={MAX_CHARS}
            value={question} onChange={e => update(index, e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); setEditing(null); } }} />
          <button type="button" onClick={() => setEditing(null)} aria-label={t('wxo_question_done')}>✓</button>
          <button type="button" onClick={() => { onChange(questions.filter((_, i) => i !== index)); setEditing(null); }}
            aria-label={t('remove')}>×</button>
        </div> :
        <button key={index} type="button" className="wix-question-chip" onClick={() => setEditing(index)}
          aria-label={`${t('wxo_questions_edit')}: ${question}`}>
          <span>{question || t('wxo_question_placeholder')}</span><span aria-hidden="true">✎</span>
        </button>)}
      {questions.length < 3 && <button type="button" className="wix-question-add" onClick={() => {
        onChange([...questions, '']); setEditing(questions.length);
      }}>+ {t('wxo_question_add')}</button>}
    </div>
  </section>;
}
